import { useState } from 'react';
import { VipTransferForm } from './components/VipTransferForm';
import { VipTransferSuccess } from './components/VipTransferSuccess';
import { VIP_TRANSFER_STATUS } from './types';

export const VipTransferFormCard = () => {
  const [status, setStatus] = useState<VIP_TRANSFER_STATUS>(
    VIP_TRANSFER_STATUS.FORM
  );

  const contentByStatus: Record<VIP_TRANSFER_STATUS, () => JSX.Element> = {
    [VIP_TRANSFER_STATUS.FORM]: () => (
      <VipTransferForm
        onSuccess={() => setStatus(VIP_TRANSFER_STATUS.SUCCESS)}
      />
    ),
    [VIP_TRANSFER_STATUS.SUCCESS]: () => <VipTransferSuccess />,
  };

  return <>{contentByStatus[status]()}</>;
};
